import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SPOtherAchievementCatalogFormLocMap } from '../other-achievement-catalog-form/other-achievement-catalog-form.locs';

const pathStart = 'Other Achievements|Catalog|Edit Dialog|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	portal: 'SP',
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	htmlAllowed: false,
};

export type SPOtherAchievementCatalogEditLocNames =
	| 'SPOtherAchievementCatalogEditTitle'
	| 'SPOtherAchievementCatalogEditVendor'
	| 'SPOtherAchievementCatalogEditVendorReq'
	| 'SPOtherAchievementCatalogEditName'
	| 'SPOtherAchievementCatalogEditNameReq'
	| 'SPOtherAchievementCatalogEditExternalId'
	| 'SPOtherAchievementCatalogEditReimbursable'
	| 'SPOtherAchievementCatalogEditSuccess'
	| 'SPOtherAchievementCatalogEditError'
	| 'SPOtherAchievementCatalogEditSaveAction'
	| 'SPOtherAchievementCatalogEditCancelAction';

export const spOtherAchievementCatalogEditLocs: LocDefs<SPOtherAchievementCatalogEditLocNames> = {
	SPOtherAchievementCatalogEditTitle: {
		defaultValue: 'Edit Other Achievement',
		description: 'Title for the dialog to add an other achievement',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditVendor: {
		defaultValue: 'Sponsor/Vendor',
		description: 'Label for the vendor field',
		displayPath: `${pathStart}Vendor`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditName: {
		defaultValue: 'Achievement Name',
		description: 'Label for the name field',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditVendorReq: {
		defaultValue: 'Sponsor/Vendor is Required',
		description: 'Error displayed when the sponsor/vendor field is empty',
		displayPath: `${pathStart}Vendor Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditNameReq: {
		defaultValue: 'Achievement Name is Required',
		description: 'Error displayed when the name field is empty',
		displayPath: `${pathStart}Name Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditExternalId: {
		defaultValue: 'Achievement Code',
		description: 'Label for the achievement code field',
		displayPath: `${pathStart}Code`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditReimbursable: {
		defaultValue: 'Reimbursable',
		description: 'Label for the reimbursable checkbox',
		displayPath: `${pathStart}Reimbursable`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditSuccess: {
		defaultValue: 'Other achievement updated successfully',
		description: 'Notification message for a successful save',
		displayPath: `${pathStart}Success`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditError: {
		defaultValue: 'There was a problem updating the other achievement',
		description: 'Notification message for an error saving',
		displayPath: `${pathStart}Error`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditSaveAction: {
		defaultValue: 'Edit Other Achievement',
		description: 'Text for the save button',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPOtherAchievementCatalogEditCancelAction: {
		defaultValue: 'Cancel',
		description: 'Text for the cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPOtherAchievementCatalogEditLocType = LocMap<SPOtherAchievementCatalogEditLocNames>;

export const editFormLocs: SPOtherAchievementCatalogFormLocMap<SPOtherAchievementCatalogEditLocType> = {
	VendorLabel: 'SPOtherAchievementCatalogEditVendor',
	NameLabel: 'SPOtherAchievementCatalogEditName',
	VendorRequired: 'SPOtherAchievementCatalogEditVendorReq',
	NameRequired: 'SPOtherAchievementCatalogEditNameReq',
	ExternalIdLabel: 'SPOtherAchievementCatalogEditExternalId',
	ReimbursableLabel: 'SPOtherAchievementCatalogEditReimbursable',
	SaveButton: 'SPOtherAchievementCatalogEditSaveAction',
	CancelButton: 'SPOtherAchievementCatalogEditCancelAction',
};
